
Checkout.Login.Lookup = function(checkout, login) {
	var lookup = this;

	this.request = false;

	this.$wrap = $('#login-lookup');
	this.$loading = $('#login-lookup-overlay');
	this.$error = $('#login-lookup-error');
	this.$errorMsg = this.$error.find('.msg-text');

	this.$search = $('#login-lookup-search');
	this.$resultWrap = $('#login-lookup-result-wrap');
	this.$resultContainer = $('#login-lookup-result-container');
	this.$resultTpl = $('#login-lookup-result-tpl');

	this.init = function() {
		if (checkout.user) {
			lookup.listen();
			lookup.$wrap.show();
		}
	};

	this.listen = function() {

		lookup.$search.bind('input propertychange', function() {

			if (lookup.request)
				lookup.request.abort();

			checkout.delayChange(lookup.$search, 1000, function() {
				lookup.search();
			});

		});

		lookup.$resultTpl.find('button').click(function() {
			lookup.selectResult($(this).parents('.address').first());
		});
	};

	this.search = function() {
		var query = lookup.$search.val();

		lookup.$resultWrap.hide();
		lookup.$resultContainer.empty();

		if (query.length < 4)
			return;

		lookup.$resultWrap.show();

		lookup.error(false);
		lookup.loading(true);

		lookup.request = checkout.remote.call({
			'data': {
				'step': 'billship',
				'action': 'lookup',
				'query': query
			}
		})
			.done(function(response) {
				lookup.showResults(response.data);
			})
			.fail(function(request) {
				lookup.error((checkout.remote.getErrorMsg(request) || 'Customer Lookup Failed'));
				lookup.$resultWrap.hide();
			})
			.always(function() {
				lookup.loading(false);
			});
	};

	this.showResults = function(results) {
		var $results = [];

		$.each(results, function(i, result) {
			var $result =
				lookup.$resultTpl
					.clone(true)
					.attr('id', '')
					.attr('data-customerid', result.customerID);

			for (var i in result)
				if (!result[i])
					result[i] = '';

			$result.find('.lookup-result-name_email').html(
				result.name_first + ' ' + result.name_last
				+ '<br />'
				+ result.email
			);

			$result.find('.lookup-result-address').html(
				result.address
				+ '<br />'
				+ ((!result.city && !result.state && !result.zip) ? '' : (result.city + ', ' + result.state + ' ' + result.zip))
				+ '<br />'
				+ result.country
			);

			$result.find('.lookup-result-phone').html(
				result.phone
			);

			$results.push($result);
		});

		lookup.$resultContainer.html($results);
	};

	this.selectResult = function($result) {
		var customerID = $result.attr('data-customerid');

		login.login.loading('Logging In');

		return checkout.remote.call({
			'data': {
				'step': 'billship',
				'action': 'loginByCustomerID',
				'customerID': customerID
			}
		})
			.done(function(response) {

				login.login.$headerLogin.replaceWith(
					'<a class="logout-link js-login-link" href="/MyAccount/Logout/" title="Sign out of My Account">Sign Out</a>'
				);
				
				if (response.data) {
					if (response.data.shipID && response.data.shippingAddresses && response.data.shippingAddresses.length > 0) {
						$.each(response.data.shippingAddresses, function(indx, shippingAddress){
							if (shippingAddress.shipID == response.data.shipID) {
								response.data.shipping.address1 = shippingAddress.ship_address;
								response.data.shipping.address2 = shippingAddress.ship_address2;
								response.data.shipping.city = shippingAddress.ship_city;
								response.data.shipping.company = shippingAddress.ship_company;
								response.data.shipping.country = shippingAddress.ship_country;
								response.data.shipping.firstname = shippingAddress.ship_name_first;
								response.data.shipping.lastname = shippingAddress.ship_name_last;
								response.data.shipping.phone = shippingAddress.ship_phone;
								response.data.shipping.phone_alternate = shippingAddress.ship_phone_alternate;
								response.data.shipping.state = shippingAddress.ship_state;
								response.data.shipping.zip = shippingAddress.ship_zip;
								return false;
							}
						});
					}
					if (response.data.billID && response.data.billingAddresses && response.data.billingAddresses.length > 0) {
						$.each(response.data.billingAddresses, function(indx, billingAddress){
							if (billingAddress.billID == response.data.billID) {
								response.data.billing.address1 = billingAddress.address;
								response.data.billing.address2 = billingAddress.address2;
								response.data.billing.city = billingAddress.city;
								response.data.billing.company = billingAddress.company;
								response.data.billing.country = billingAddress.country;
								response.data.billing.firstname = billingAddress.name_first;
								response.data.billing.lastname = billingAddress.name_last;
								response.data.billing.state = billingAddress.state;
								response.data.billing.zip = billingAddress.zip;
								return false;
							}
						});
					}
				}
				
				checkout.session.load(response.data);
				
				if (response.data) {
					// ensure a billship object exists
					if (!checkout.billship)
						checkout.billship = new Checkout.BillShip( checkout );
					if (response.data.billID && response.data.billingAddresses && response.data.billingAddresses.length > 0) {
						$.each(response.data.billingAddresses, function(indx, billingAddress){
							if (billingAddress.billID == response.data.billID) {
								checkout.billship.$billing.state.val(billingAddress.state);
								checkout.billship.$billing.zip.val(billingAddress.zip);
								return false;
							}
						});
					}
					if (response.data.shipID && response.data.shippingAddresses && response.data.shippingAddresses.length > 0) {
						$.each(response.data.shippingAddresses, function(indx, shippingAddress){
							if (shippingAddress.shipID == response.data.shipID) {
								checkout.cart.shipping.$country.val(shippingAddress.ship_country);
								checkout.cart.shipping.$zip.val(shippingAddress.ship_zip);
								if (checkout.billship) {
									checkout.billship.$shipping.state.val(shippingAddress.ship_state);
									checkout.billship.$billing.phone.val(shippingAddress.ship_phone);
								}
								return false;
							}
						});
					}
				}
				var promise;
				if (response.data.refreshCart) {
					promise = checkout.cart.checkItems(true, true);
				} else {
					promise = checkout.cart.checkItems();
				}
				promise.then(function() {
					login.proceed();
					checkout.cart.shipping.calc(false, false, true);
				});
			})
			.fail(function(request) {
				lookup.error('Failed to Login As Selected Customer');
			})
			.always(function() {
				login.login.loading(false);
			});
	};

	this.loading = function(show) {
		if (show) {
			lookup.$loading.show();
			checkout.alignMiddle(lookup.$loading.find('.msg'), lookup.$loading);
		} else
			lookup.$loading.hide();
	};

	this.error = function(errorMsg) {
		if (errorMsg) {
			var currentMsg = lookup.$errorMsg.html();

			if (currentMsg)
				lookup.$errorMsg.html(currentMsg + '<br />' + errorMsg);
			else
				lookup.$errorMsg.html(errorMsg);

			lookup.$error.show();
		} else {
			lookup.$error.hide();
			lookup.$errorMsg.html('');
		}
	};

	this.init();
};

